<!-- document.component.html -->
<div class="bg-gray-50 min-h-screen p-6">
  <div class="max-w-7xl mx-auto">
    <h1 class="text-3xl font-bold text-gray-800 mb-8">Documents</h1>
    
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <!-- Section Nouveau document -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 class="text-xl font-semibold text-gray-700 mb-6">Nouveau document</h2>
        
        <div class="space-y-4">
          <!-- Libellé -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Libellé
            </label>
            <input
              type="text"
              [(ngModel)]="documentForm.label"
              placeholder="Ex: Contrat"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-gray-700"
            />
          </div>

          <!-- Code -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Code
            </label>
            <input
              type="text"
              [(ngModel)]="documentForm.code"
              placeholder="Ex: DOC001"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-gray-700"
            />
          </div>
          
          <!-- Checkboxes -->
          <div class="space-y-3">
            <label class="flex items-center">
              <input
                type="checkbox"
                [(ngModel)]="documentForm.hasStartDate"
                class="h-4 w-4 text-orange-500 focus:ring-orange-500 border-gray-300 rounded"
              />
              <span class="ml-2 text-sm text-gray-700">Exige date début</span>
            </label>
            
            <label class="flex items-center">
              <input
                type="checkbox"
                [(ngModel)]="documentForm.hasEndDate"
                class="h-4 w-4 text-orange-500 focus:ring-orange-500 border-gray-300 rounded"
              />
              <span class="ml-2 text-sm text-gray-700">Exige date fin</span>
            </label>
          </div>
          
          <!-- Bouton Ajouter -->
          <button
            (click)="ajouterDocument()"
            [disabled]="!documentForm.label.trim() || !documentForm.code.trim() || isSubmitting"
            class="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-medium py-2.5 px-4 rounded-md transition-colors duration-200"
          >
            <span *ngIf="isSubmitting">Ajout en cours...</span>
            <span *ngIf="!isSubmitting">Ajouter</span>
          </button>
        </div>
      </div>
      
      <!-- Section Liste des documents -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-semibold text-gray-700">Liste des documents</h2>
          <div class="text-sm text-gray-500">
            Total: {{ totalDocuments }}
          </div>
        </div>

        <!-- Barre de recherche -->
        <div class="mb-4">
          <div class="relative">
            <input
              type="text"
              [(ngModel)]="searchTerm"
              (input)="onSearch()"
              placeholder="Rechercher un document..."
              class="w-full px-3 py-2 pl-10 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            />
            <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
            <button 
              *ngIf="searchTerm"
              (click)="clearSearch()"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>
        
        <!-- Loading indicator -->
        <div *ngIf="isLoading" class="text-center py-8">
          <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
          <p class="mt-2 text-gray-500">Chargement...</p>
        </div>

        <!-- Table -->
        <div *ngIf="!isLoading" class="overflow-x-auto">
          <table class="w-full">
            <thead>
              <tr class="border-b border-gray-200">
                <th class="text-left py-3 px-2 font-medium text-gray-600 text-sm">Libellé</th>
                <th class="text-left py-3 px-2 font-medium text-gray-600 text-sm">Code</th>
                <th class="text-left py-3 px-2 font-medium text-gray-600 text-sm">Date de début</th>
                <th class="text-left py-3 px-2 font-medium text-gray-600 text-sm">Date de fin</th>
                <th class="text-left py-3 px-2 font-medium text-gray-600 text-sm">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let document of documents" class="border-b border-gray-100 hover:bg-gray-50">
                <!-- Mode édition -->
                <ng-container *ngIf="isEditing(document); else viewMode">
                  <!-- Libellé en édition -->
                  <td class="py-4 px-2">
                    <input
                      type="text"
                      [(ngModel)]="editForm.label"
                      class="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-orange-500"
                    />
                  </td>
                  
                  <!-- Code en édition -->
                  <td class="py-4 px-2">
                    <input
                      type="text"
                      [(ngModel)]="editForm.code"
                      class="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-orange-500"
                    />
                  </td>
                  
                  <!-- Date de début en édition -->
                  <td class="py-4 px-2">
                    <div class="flex items-center justify-center">
                      <input
                        type="checkbox"
                        [(ngModel)]="editForm.hasStartDate"
                        class="h-4 w-4 text-orange-500 focus:ring-orange-500 border-gray-300 rounded"
                      />
                    </div>
                  </td>
                  
                  <!-- Date de fin en édition -->
                  <td class="py-4 px-2">
                    <div class="flex items-center justify-center">
                      <input
                        type="checkbox"
                        [(ngModel)]="editForm.hasEndDate"
                        class="h-4 w-4 text-orange-500 focus:ring-orange-500 border-gray-300 rounded"
                      />
                    </div>
                  </td>
                  
                  <!-- Actions en édition -->
                  <td class="py-4 px-2">
                    <div class="flex items-center space-x-2">
                      <button 
                        (click)="sauvegarderModification()"
                        class="p-1.5 text-green-500 hover:text-green-700 hover:bg-green-50 rounded"
                        title="Sauvegarder"
                      >
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                        </svg>
                      </button>
                      <button 
                        (click)="annulerModification()"
                        class="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-50 rounded"
                        title="Annuler"
                      >
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                        </svg>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <!-- Mode visualisation -->
                <ng-template #viewMode>
                  <!-- Libellé -->
                  <td class="py-4 px-2 text-gray-800 font-medium">
                    {{ document.label }}
                  </td>
                  
                  <!-- Code -->
                  <td class="py-4 px-2 text-gray-600">
                    {{ document.code }}
                  </td>
                  
                  <!-- Date de début -->
                  <td class="py-4 px-2">
                    <div class="flex items-center justify-center">
                      <ng-container [ngSwitch]="getStatusIcon(document.hasStartDate, document.hasStartDate)">
                        <svg *ngSwitchCase="'check'" class="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                        </svg>
                        <svg *ngSwitchCase="'x'" class="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                        </svg>
                        <span *ngSwitchDefault class="text-gray-400">-</span>
                      </ng-container>
                    </div>
                  </td>
                  
                  <!-- Date de fin -->
                  <td class="py-4 px-2">
                    <div class="flex items-center justify-center">
                      <ng-container [ngSwitch]="getStatusIcon(document.hasEndDate, document.hasEndDate)">
                        <svg *ngSwitchCase="'check'" class="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                        </svg>
                        <svg *ngSwitchCase="'x'" class="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                        </svg>
                        <span *ngSwitchDefault class="text-gray-400">-</span>
                      </ng-container>
                    </div>
                  </td>
                  
                  <!-- Actions -->
                  <td class="py-4 px-2">
                    <div class="flex items-center space-x-2">
                      <!-- Bouton Modifier -->
                      <button 
                        (click)="modifierDocument(document)"
                        class="p-1.5 text-orange-400 hover:text-orange-600 hover:bg-orange-50 rounded"
                        title="Modifier"
                      >
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path>
                        </svg>
                      </button>
                      
                      <!-- Bouton Supprimer -->
                      <button 
                        (click)="supprimerDocument(document)"
                        class="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded"
                        title="Supprimer"
                      >
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                        </svg>
                      </button>
                    </div>
                  </td>
                </ng-template>
              </tr>
              
              <!-- Message si aucun document -->
              <tr *ngIf="!hasDocuments && !isLoading">
                <td colspan="5" class="py-8 text-center text-gray-500">
                  <div *ngIf="searchTerm && !isSearching">
                    Aucun document trouvé pour "{{ searchTerm }}"
                  </div>
                  <div *ngIf="!searchTerm">
                    Aucun document trouvé
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Bouton Charger plus -->
        <div *ngIf="canLoadMore && !isLoading" class="mt-4 text-center">
          <button
            (click)="loadMore()"
            [disabled]="isLoadingMore"
            class="px-4 py-2 bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 text-white rounded-md transition-colors duration-200"
          >
            <span *ngIf="isLoadingMore">Chargement...</span>
            <span *ngIf="!isLoadingMore">Charger plus</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>